"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Calculate number of issues over a11y threshold
 *
 * @param settings - AxeDeveloperHub settings object
 * @param overview - Calculated overview
 * @returns - Number of issues over a11y threshold
 */
const a11yThresholdResults = (settings, overview) => {
    /* Exit early if settings are not defined */
    if (!settings) {
        return null;
    }
    let issuesOverA11yThreshold = 0;
    const { impacts, onlyNewIssues } = settings;
    for (const impact of Object.keys(impacts.value)) {
        const { totalCurrent, numNew } = overview.numIssueSeverity[impact];
        /* Skip impact if it's not enabled within settings */
        if (!impacts.value[impact]) {
            continue;
        }
        if (onlyNewIssues.value) {
            issuesOverA11yThreshold += numNew;
        }
        else {
            issuesOverA11yThreshold += totalCurrent;
        }
    }
    return issuesOverA11yThreshold;
};
exports.default = a11yThresholdResults;
//# sourceMappingURL=a11yThresholdResults.js.map